import React, { useEffect } from 'react';
import { cn } from '../../lib/utils';
import Icon from './Icon';

export default function Modal({ open, onClose, title, children, size = 'md', className }) {
  // بستن با Esc و قفل اسکرول صفحه‌ی پشت مودال
  useEffect(() => {
    if (!open) return undefined;

    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', onKey);

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [open, onClose]);

  if (!open) return null;

  const sizeClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    full: 'max-w-4xl',
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-ink/60 backdrop-blur-md animate-fade-in"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
      role="dialog"
      aria-modal="true"
      aria-label={typeof title === 'string' ? title : undefined}
    >
      <div
        className={cn(
          'no-glass w-full rounded-[2rem] bg-white shadow-2xl shadow-ink/30 ring-1 ring-white/70 max-h-[90vh] overflow-y-auto animate-slide-up',
          sizeClasses[size],
          className
        )}
      >
        <div className="sticky top-0 z-10 rounded-t-[2rem] border-b border-slate-100 bg-white/95 backdrop-blur">
          <div className="h-1.5 w-full rounded-t-[2rem] bg-gradient-to-r from-emerald-400 via-emerald-500 to-teal-500" />
          <div className="flex items-center justify-between px-6 py-4">
            <h2 className="text-xl font-black text-text-dark">{title}</h2>
            <button
              type="button"
              onClick={onClose}
              aria-label="بستن"
              className="grid h-9 w-9 place-items-center rounded-xl text-slate-500 transition-all hover:rotate-90 hover:bg-red-50 hover:text-red-500"
            >
              <Icon name="close" className="h-5 w-5" />
            </button>
          </div>
        </div>
        <div className="p-6">{children}</div>
      </div>
    </div>
  );
}
